import { Component, OnInit } from '@angular/core';
import { BusService } from '../../services/bus.service';
import { Bus } from '../../model/bus';
import { ColDef, GridOptions, GridReadyEvent, ICellRendererParams, RowClickedEvent } from 'ag-grid-community';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ManageBusComponent } from './manage-bus/manage-bus.component';

@Component({
  selector: 'busses',
  templateUrl: './busses.component.html',
  styleUrls: ['./busses.component.css']
})
export class BussesComponent implements OnInit {
  public fetchingData = false;
  public bussData: Bus[] = [];
  public rowSelection = {
    mode: 'singleRow',
  };

  editBusModalRef: MatDialogRef<ManageBusComponent>;

  public columnDefs: ColDef[] = [
    {
      field: "id", editable: false, hide: true
    },
    {
      headerName: 'Bussnummer', field: "number", editable: false,
      cellRenderer: function (params: ICellRendererParams) {
        let bus = params.data as Bus;
        return BussesComponent.getBusIcon(bus);
      }
    },
    {
      headerName: 'Aktuell service', field: "serviceDescription", editable: false
    },
    {
      headerName: 'Regnummer', field: "registrationNumber", editable: false
    },
    {
      headerName: 'Kort/led', field: "busType", editable: false
    },

    {
      headerName: 'Gas/El', field: "fuel", editable: false
    },
    {
      headerName: 'Aktiv', field: "active", editable: false,
      cellDataType: 'boolean'
    }
  ];

  constructor(private readonly busService: BusService,
    private readonly dialog: MatDialog) {


  }

  public static getBusIcon(bus: Bus): string {
    if (bus.active && !bus.onService) {
      return '<span><img style="margin-top: -5px" src="../assets/images/maps/landside_active.png" />&nbsp;&nbsp;' + bus.number + '</span>';
    }
    else {
      return '<span><img style="margin-top: -5px" src="../assets/images/maps/airside_inactive.png" />&nbsp;&nbsp;' + bus.number + '</span>';
    }
  }

  public gridOptions: GridOptions = {
    rowSelection: "single",
    // Event handlers
    onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
    onRowClicked: (event: RowClickedEvent) => {
      return this.onRowClick(event);
    },
    columnDefs: this.columnDefs
  };

  ngOnInit(): void {
    this.busService.getAllBuses().then((busses: Bus[]) => {
      this.bussData = busses;
      this.bussData.sort((b1: Bus, b2: Bus) => +b1.number - +b2.number);
    });

  }

  onGridReady(event: GridReadyEvent) {
    event.api.sizeColumnsToFit();
  }

  /**
   * There is an issue with bootstrap adding area-hidden to all resourses which will be blocked and warned in console. This removes focus from parant.
   *
   *  Blocked aria-hidden on an element because its descendant retained focus. The focus must not be hidden from assistive technology users.
   *  Avoid using aria-hidden on a focused element or its ancestor. Consider using the inert attribute instead, which will also prevent focus.   *
   *  For more details, see the aria-hidden section of the WAI-ARIA specification at https://w3c.github.io/aria/#aria-hidden.
   *
  */
  private fixForAriaHiddenAndBootstrap() {
    const focousedElement = document.activeElement as HTMLElement; // Get the currently focused element
    focousedElement.blur(); // Remove focus
  }

  private showBusMangeDialog(bus: Bus | undefined) {

    this.fixForAriaHiddenAndBootstrap();

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "700px";
    dialogConfig.panelClass = "";
    dialogConfig.data = { bus: bus };
    this.dialog.open(ManageBusComponent, dialogConfig).afterClosed().subscribe((response: BusManageDialogResponse) => {
      if (response === undefined) return;
      let updatedBus = response.bus;
      if (!response.created) {
        let index = this.bussData.findIndex(b => b.id === updatedBus.id);
        this.bussData.splice(index, 1);
      }

      if (!response.deleted) {
        this.bussData = this.bussData.concat([updatedBus]);
      }
      else {
        this.bussData = this.bussData.concat([]); //to trigger event in angular
      }
      this.bussData.sort((b1: Bus, b2: Bus) => +b1.number - +b2.number);
    });


  }

  createNewBus() {
    this.showBusMangeDialog(undefined);
  }

  onRowClick(event: RowClickedEvent) {
    let bus = event.data as Bus;
    this.showBusMangeDialog(bus);
  }
}

export class BusManageDialogResponse {
  bus: Bus;
  deleted: boolean;
  created: boolean;
}
